import { useEventSpaces } from "@circle-react/components/Events/hooks/useEventSpaces";
import { useCreateEventModal } from "@circle-react/components/Modals/CreateEventModal";

export const useCreateEvent = () => {
  const { spaceId } = useEventSpaces();
  const createEventModal = useCreateEventModal();
  const showCreateEventModal = () => createEventModal.show({ spaceId });

  return {
    showCreateEventModal,
  };
};
